import { gql } from "@apollo/client";

import { TENANT_FIELDS } from "./loggedInInfo";

export const TENANT_STAFF_FIELDS = gql`
  ${TENANT_FIELDS}
  fragment TenantStaffFields on Tenant {
    bandwidthAvailableMessageClasses

    bandwidthRegisteredApplicationInfo {
      accountId
      applicationId
      locationId
      subaccountId
      isDefault
    }

    bandwidthUnregisteredApplicationInfo {
      accountId
      applicationId
      locationId
      subaccountId
      isDefault
    }

    bandwidthShortCodeApplicationInfo {
      accountId
      applicationId
      locationId
      subaccountId
      isDefault
    }

    bandwidthTollFreeApplicationInfo {
      accountId
      applicationId
      locationId
      subaccountId
      isDefault
    }

    releasePhoneNumbersJob {
      id
      createdAt
      status
      errorMessage
      result {
        fakeNumbersReleased
        bandwidthNumbersReleased
        twilioNumbersReleased
        sinchNumbersReleased
      }
    }

    ...TenantFields
  }
`;

export const GET_TENANT_FOR_STAFF = gql`
  ${TENANT_STAFF_FIELDS}
  query GetTenantForStaff {
    getTenant {
      ...TenantStaffFields
    }
  }
`;

export const TENANT_ENABLE_SUBACCOUNTS = gql`
  ${TENANT_FIELDS}
  mutation TenantEnableSubaccounts {
    enableSubaccounts {
      ...TenantFields
    }
  }
`;

export const LIST_TENANTS = gql`
  ${TENANT_STAFF_FIELDS}
  query ListTenants {
    listTenants {
      bandwidthAvailableMessageClasses
      ...TenantStaffFields
    }
  }
`;

export const LIST_TENANTS_WITH_SUBACCOUNTS = gql`
  query ListTenantsWithSubaccounts {
    listTenants {
      id
      name
      slug
      subaccountsEnabled
      defaultSubaccount {
        id
        name
      }
      subaccounts {
        id
        name
        slug
      }
    }
  }
`;

export const CREATE_TENANT = gql`
  ${TENANT_STAFF_FIELDS}
  mutation CreateTenant($input: CreateTenantInput!) {
    createTenant(input: $input) {
      ...TenantStaffFields
    }
  }
`;

export const EDIT_TENANT_SETTINGS = gql`
  ${TENANT_FIELDS}
  mutation EditTenantSettings($input: EditTenantSettingsInput!) {
    editTenantSettings(input: $input) {
      ...TenantFields
    }
  }
`;

export const TOGGLE_OPT_OUT_SHARING = gql`
  ${TENANT_FIELDS}
  mutation ToggleOptOutSharing($input: ToggleOptOutSharingInput!) {
    toggleOptOutSharing(input: $input) {
      ...TenantFields
    }
  }
`;

export const EDIT_TENANT_AUTO_MMS_BREAKPOINT = gql`
  ${TENANT_FIELDS}
  mutation EditTenantAutoMMSBreakpoint(
    $input: EditTenantAutoMMSBreakpointInput!
  ) {
    editTenantAutoMMSBreakpoint(input: $input) {
      ...TenantFields
    }
  }
`;

export const EDIT_TENANT_FEATURE_FLAGS = gql`
  ${TENANT_FIELDS}
  mutation EditTenantFeatureFlags($input: EditTenantFeatureFlagsInput!) {
    editTenantFeatureFlags(input: $input) {
      ...TenantFields
    }
  }
`;

export const DEACTIVATE_TENANTS = gql`
  mutation DeactivateTenants($input: DeactivateTenantsInput!) {
    deactivateTenants(input: $input)
  }
`;

export const REACTIVATE_TENANTS = gql`
  mutation ReactivateTenants($input: ReactivateTenantsInput!) {
    reactivateTenants(input: $input)
  }
`;

export const RELEASE_TENANT_PHONE_NUMBERS = gql`
  mutation ReleaseTenantPhoneNumbers {
    releaseTenantPhoneNumbers {
      id
      status
      errorMessage
      result {
        fakeNumbersReleased
        bandwidthNumbersReleased
        twilioNumbersReleased
        sinchNumbersReleased
      }
    }
  }
`;
